// Password-manager hand-off.
//
// Browsers decide on their own whether a form submission was a sign-up or a
// login worth saving, and an SPA gives them little to go on: no page load, and
// on sign-up the password may have been filled in by our generator rather than
// typed. Chromium browsers (Chrome, Edge, Opera) take an explicit hint through
// the Credential Management API and then show their "Save password?" prompt —
// for Chrome that is Google Password Manager. Safari and Firefox have no such
// API and keep relying on the form's `autocomplete` attributes.

// Chromium-only, so not in lib.dom.
type PasswordCredentialCtor = new (data: {
  id: string;
  password: string;
  name?: string;
}) => Credential;

/** Asks the browser to save (or update) the credential the user just set or
 *  used. Best effort: resolves quietly when the API is missing, the user has
 *  turned saving off, or the prompt is dismissed. Do not await it before
 *  navigating — the prompt can stay open for as long as the user likes. */
export async function offerToSavePassword(
  email: string,
  password: string,
  name?: string,
): Promise<void> {
  if (!email || !password) return;
  const Ctor = (globalThis as { PasswordCredential?: PasswordCredentialCtor }).PasswordCredential;
  const container = globalThis.navigator?.credentials;
  if (!Ctor || !container) return;
  try {
    await container.store(new Ctor(name ? { id: email, password, name } : { id: email, password }));
  } catch {
    // Declined, blocked by policy, or not allowed in this context.
  }
}
